import { ICandidate, newMappingEntity } from 'wisestep-api';

import JobServeCandidates from '../types/JobServeCandidates';
import JobServeResponse from '../types/JobServeResponse';

export const processJobServeResponse = (response: any): JobServeResponse => {
  let existing: any = null;
  let noresponse = false;
  const modifiedResponse: JobServeResponse = {
    candidates: [],
  };
  console.log(response.Envelope);
  if (response.Envelope?.Existing?.interaction) {
    if (Array.isArray(response.Envelope.Existing.interaction)) {
      existing = response.Envelope.Existing.interaction;
    } else {
      existing = [response.Envelope.Existing.interaction];
    }
  } else {
    existing = [];
  }

  const totalItems = response.Envelope.Body.SearchResults.Summary.Count;

  if (!response.Envelope.Body.SearchResults?.Results?.Result) {
    noresponse = true;
  }
  const candidates = response.Envelope.Body.SearchResults.Results.Result
    ? Array.isArray(response.Envelope.Body.SearchResults.Results.Result)
      ? response.Envelope.Body.SearchResults.Results.Result
      : [response.Envelope.Body.SearchResults.Results.Result]
    : [];
  const candidatesResponse = buildCandidateRecords(candidates);
  modifiedResponse.candidates = candidatesResponse;
  modifiedResponse.noResponse = noresponse;
  modifiedResponse.totalItems = totalItems;
  modifiedResponse.existing = existing;
  return modifiedResponse;
};

function buildCandidateRecords(candidates: JobServeCandidates[]): JobServeCandidates[] {
  candidates.map((candidate) => {
    const candidateData: ICandidate = newMappingEntity();
    candidateData.name = `${candidate.FullName ?? '-'}`;
    if (typeof candidate.FullName === 'object') {
      candidateData.name = `-`;
    }
    if (candidate.UpdatedDate) {
      candidate.UpdatedDate = candidate.UpdatedDate.replace('AM', ' AM').replace('PM', ' PM');
    }
    if (candidate.LastApplication) {
      const datearray = candidate.LastApplication.split('/');
      candidate.LastApplication = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
      candidateData.dateLastActiveOnJobBoard = candidate.LastApplication;
    }
    candidateData.currentJobTitle = candidate.CurrentJob;
    candidateData.dateResumeLastUpdatedOnJobBoard = candidate.UpdatedDate;
    candidateData.source = 'JOBSERVESEARCH';
    candidate.candidateData = candidateData;
  });
  return candidates;
}
